import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import HomeLayout from "../HomeLayout/HomeLayout"
import CoolLightbox from "../LightBox/CoolLightBox"
const Page5 = ({onChange}) => {
  const [isOpen, setOpen] = useState(false)
  const [currentImageIndex, setCurrentIndex] = useState(0)

  const data = useStaticQuery(graphql`
    query {
      Page5: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "EventManagementPage5" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      EventManagementInfoPage5: allFile(
        sort: { order: ASC, fields: name }
        filter: { sourceInstanceName: { eq: "EventManagementInfoPage5" } }
      ) {
        nodes {
          id
          name
          childImageSharp {
            fluid {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  var images = []
  data.EventManagementInfoPage5.nodes.map(img => {
    var src = img.childImageSharp.fluid.src
    images.push({
      src,
    })
  })

  return (
    <HomeLayout>
        <>
          {data.Page5.nodes.map((img, index) => {
            if(index===4) return <Img fluid={img.childImageSharp.fluid} />
            if(index===5) index = index-1
            return (
              <div
                onClick={() => {
                  setCurrentIndex(index)
                  setOpen(true)
                  onChange(false)
                }}
              >
                <Img fluid={img.childImageSharp.fluid} />
              </div>
            )
          })}
          <CoolLightbox
           images={images}
           setCurrentIndex={setCurrentIndex}
           currentImageIndex={currentImageIndex}
           isOpen={isOpen}
           onClose={() =>{ setOpen(false)
            onChange(true)}}
          />
          
        </>
        </HomeLayout>
  )
}
export default Page5

